module.exports = __webpack_public_path__ + "static/media/guanzu.73df597d.png";